import { useEffect, useState } from "react";
import { toast } from "sonner";
import { errText } from "@/lib/api";
import { Panel, Btn, inputCls } from "./ui";

// Admin → Controls → 333 Helpers site: every piece of copy on 333helpers.com.
export function HelpersControls({ api, s, setS, Field }) {
  const [fields, setFields] = useState([]);
  useEffect(() => { api.get("/helpers-fields").then((r) => setFields(r.data)).catch(() => {}); }, [api]);
  const copy = s.helpers_site || {};
  const set = (k) => (e) => setS({ ...s, helpers_site: { ...copy, [k]: e.target.value } });
  const save = async () => {
    try { const r = await api.put("/settings", { helpers_site: copy }); setS(r.data); toast.success("Saved"); }
    catch (e) { toast.error(errText(e)); }
  };
  return (
    <Panel title="333 Helpers site (333helpers.com)" actions={<Btn data-testid="controls-save-helpers-site" onClick={save}>Save</Btn>}>
      <div className="grid gap-3 md:grid-cols-2" data-testid="controls-helpers-site">
        {fields.map((f) => (
          <Field key={f.key} label={f.label}>
            {(f.default || "").length > 70
              ? <textarea data-testid={`controls-helpers-${f.key}`} className={`${inputCls} h-20`} value={copy[f.key] ?? f.default} onChange={set(f.key)} />
              : <input data-testid={`controls-helpers-${f.key}`} className={inputCls} value={copy[f.key] ?? f.default} onChange={set(f.key)} />}
          </Field>
        ))}
      </div>
    </Panel>
  );
}
